import { gql } from "apollo-boost";

export const CREATE_VOX = gql`
  mutation createSignedUrl($contentType:String!, $recordingUrl:String, $firstName: String!, $email: String!, $mobile: String, $channelToken: String!, $createdBy: String!, $createdById: Int!, $length: Int!, $tagIds:[String!] ) {
    createVox(input: {
      kind: "In",
      contentType: $contentType,
      recordingUrl: $recordingUrl,
      firstName: $firstName,
      email: $email,
      mobile: $mobile,
      channelToken: $channelToken,
      createdBy: $createdBy,
      createdById: $createdById,
      length: $length,
      tagIds: $tagIds,
      }) {
      vox {
          id
          token
      }
      signedUrl
    }        
  }
`;

export const QUERY_VOX_URL = gql`
  query getVoxUrl($id:ID!) {
    getVox(id: $id){
      recordingUrl  
    }
  }
`;
export const Get_Recorder_Tags = gql`
 query getRecorderTagsData($channelToken: String!){
   getRecorderTags(channelToken: $channelToken) {
     category
     categoryIconColour
     channelId
     description
     dropdownOrder
     emailRequired
     emailVerificationNeeded
     fontAwesomeIcon
     id
     publicTag
     showInRecorder
     tagName
     tagText
     thankyouText
     domainToVerify
   }  
 }
`;
